import { TypedEmitter } from 'tiny-typed-emitter';
/**
 * 相比基础版本的 EventEmitter，这个还提供了 subscribe 方法，调用后会返回一个 unsubscribe 方法，方便 dispose 的实现
 */
export class EventEmitter extends TypedEmitter {
  /**
   * @returns a function to unsubscribe
   */
  subscribe(event, listener) {
    this.on(event, listener);
    return () => {
      this.off(event, listener);
    };
  }
  /**
   * @returns a function to unsubscribe
   */
  subscribeOnce(event, listener) {
    this.once(event, listener);
    return () => {
      this.off(event, listener);
    };
  }
}
//# sourceMappingURL=eventEmitter.js.map
